import { makeAutoObservable } from 'mobx';

export class TopEventsSportSectionWrapperState {
    public isOpenedSport: boolean = true;

    public constructor() {
        makeAutoObservable(this);
    }

    public setIsOpened = (): void => {
        this.isOpenedSport = !this.isOpenedSport;
    };
}
